/**
 * Format a birth date (epoch ms) into a human-readable age string.
 */
export function formatAge(birthDateMs: number): string {
  const now = new Date();
  const birth = new Date(birthDateMs);
  const diffMs = now.getTime() - birth.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays < 30) return 'newborn';

  const months = Math.floor(diffDays / 30.44);
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} old`;

  const years = Math.floor(months / 12);
  return `${years} year${years === 1 ? '' : 's'} old`;
}
